import clsx from 'clsx'
import { trialText } from '~/config'
import { Button } from '~/components-v2'

export const CallToAction = ({
  children,
  className,
  intent = 'primary',
}: {
  children?: string
  className?: string
  intent?: 'primary' | 'outline'
}) => {
  const { to, cta } = trialText
  const variant = intent === 'outline' ? 'secondary' : 'primary'

  return (
    <Button
      className={clsx('call-to-action', intent, className)}
      to={to}
      variant={variant}
    >
      {children} {cta}
    </Button>
  )
}
